import { render, staticRenderFns } from "./Spells.vue?vue&type=template&id=747f1330&"
import script from "./Spells.vue?vue&type=script&lang=js&"
export * from "./Spells.vue?vue&type=script&lang=js&"
import style0 from "./Spells.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports